import './calculator-submit';
document.addEventListener("DOMContentLoaded", () => {

    let fileBox = document.querySelectorAll(".calculation__file-label");
    if (fileBox) {
        fileBox.forEach((item) => {
            let fileInput = item.querySelector(".calculation__file-input");
            let uploadText = item.querySelector(".calculation__upload");
            const uploadTextDefault = uploadText.textContent;
            fileInput.addEventListener("change", function () {
                if (fileInput.files.length > 0) {
                    uploadText.textContent = fileInput.files[0].name;
                } else {
                    uploadText.textContent = uploadTextDefault;
                }
            });
        });
    }




    let formPersonal = document.querySelector('.personal-popup__form');
    let popupClose = document.querySelector('.personal-popup__close');

    popupClose.addEventListener('click', () => {
        popup.classList.remove('visible');

    });

    formPersonal.addEventListener('submit', (e) => {
        e.preventDefault();
        let formData = new FormData(formPersonal);


        fetch(document.querySelector('body').dataset.ajax, {
            method: 'POST',
            body: formData,
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    console.log('Данные успешно отправлены:', data);
                } else {
                    console.error('Ошибка при отправке данных:', data);
                }
            })
            .catch(error => {
                console.error('Произошла ошибка:', error);
            });

        popup.classList.remove('visible');
        popupConfirm.classList.add('visible');

    })

    let popupCancelBack = document.querySelector('.confirm-phone-popup__change');

    popupCancelBack.addEventListener('click', () => {
        popupConfirm.classList.remove('visible');
        popup.classList.add('visible');
    })

    const resendButton = document.getElementById('resendButton');
    const timerElement = document.getElementById('timer');

    let timeLeft = 58; // Оставшееся время в секундах
    let timerInterval; // Переменная для хранения интервала

    // Функция для обновления таймера
    function updateTimer() {
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
        timerElement.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }

    // Таймер, который обновляет счетчик каждую секунду


    // Обработчик клика по кнопке "Отправить повторно"
    function resendClickHandler(event) {
        event.preventDefault(); // Отменяем стандартное поведение ссылки
        popupConfirm.classList.remove('visible');
        popup.classList.add('visible');
    }


    let popupConfirmForm = document.querySelector('.confirm-phone-popup__form'); // Кнопка подтверждения в попапе
     // Кнопка отмены в попапе
  // Попап успешной отправки
   // Кнопка закрытия попапа успешной отправки

    let finalPopupClose = document.querySelector('.final-popup__close');
    let finalPopup = document.querySelector('.final-popup');
    let finalPopupForm = document.querySelector('.final-popup__form');


    // let form = document.querySelector('.calculation__send');
    // let popup = document.querySelector('.personal-popup');
    // let popupConfirm = document.querySelector('.confirm-phone-popup'); // Предполагается, что попап есть в HTML
    //
    // form.addEventListener('submit', (e) => {
    //     e.preventDefault();
    //     let formData = new FormData(form);
    //     finalPopup.classList.add('visible');
    //
    //     startTimer();
    // });



    // popupConfirmForm.addEventListener('submit', (e) => {
    //
    //     e.preventDefault();
    //     const formData = new FormData(popupConfirmForm);
    //
    //     const termSelect = document.getElementById("term");
    //     const amountInput = document.getElementById("amount");
    //     const rangeInput = document.getElementById("sum");
    //     const annualInput = document.getElementById("annual");
    //     const monthPayValue = document.querySelector(".month-pay-value");
    //     const overpaymentValue = document.querySelector(".total-cost-value");
    //     const totalCostInput = document.querySelector(".total");
    //     const inputPhone = document.querySelector(".calculation__input-phone");
    //
    //     document.querySelector(".final-popup__phone").value = inputPhone.value;
    //     document.querySelector(".final-popup__term").value = termSelect.options[termSelect.selectedIndex].text;
    //     document.querySelector(".final-popup__annual-rate").value = annualInput.value;
    //     document.querySelector(".final-popup__pay-month").value = monthPayValue.textContent;
    //     document.querySelector(".final-popup__credit-sum").value = rangeInput.value;
    //
    //     let codeInput = document.querySelector(".confirm-phone-popup__in");
    //
    //
    //     fetch(document.querySelector('body').dataset.ajax, {
    //         method: 'POST',
    //         body: formData,
    //         headers: {
    //             'Accept': 'application/json',
    //         }
    //     })
    //         .then(response => response.json())
    //         .then(data => {
    //             if (data.success) {
    //                     console.log('Данные успешно отправлены:', data);
    //                     finalPopupForm.reset();
    //                     formPersonal.reset();
    //
    //                     popupConfirm.classList.remove('visible');
    //                     popupConfirmForm.classList.remove('visible');
    //                     finalPopup.classList.remove('visible');
    //                     successPopup.classList.add('visible');
    //             } else {
    //                 codeInput.classList.add('error');
    //                 console.error('Ошибка при отправке данных:', data);
    //             }
    //         })
    //         .catch(error => {
    //             codeInput.classList.add('error');
    //             console.error('Произошла ошибка:', error);
    //         });
    // });

    // finalPopupForm.addEventListener('submit', (e) => {
    //
    //     e.preventDefault();
    //     const formData = new FormData(finalPopupForm);
    //     finalPopupForm.querySelector('button').disabled = true; // Disable submit button
    //     finalPopupForm.querySelector('button').textContent = 'Отправка...';
    //     fetch(document.querySelector('body').dataset.ajax, {
    //         method: 'POST',
    //         body: formData,
    //         headers: {
    //             'Accept': 'application/json',
    //         }
    //     })
    //         .then(response => response.json())
    //         .then(data => {
    //             if (data.success) {
    //                 console.log('Данные успешно отправлены:', data);
    //                 finalPopupForm.reset();
    //                 formPersonal.reset();
    //
    //                 popupConfirm.classList.remove('visible');
    //                 popupConfirmForm.classList.remove('visible');
    //                 finalPopup.classList.remove('visible');
    //                 successPopup.classList.add('visible');
    //             } else {
    //                 console.error('Ошибка при отправке данных:', data);
    //             }
    //             finalPopupForm.querySelector('button').disabled = false; // Disable submit button
    //             finalPopupForm.querySelector('button').textContent = 'Отправить';
    //
    //         })
    //         .catch(error => {
    //             console.error('Произошла ошибка:', error);
    //             finalPopupForm.querySelector('button').disabled = false; // Disable submit button
    //             finalPopupForm.querySelector('button').textContent = 'Отправить';
    //
    //         });
    //
    //
    //     setTimeout(() => {
    //         successPopup.classList.remove('visible');
    //     }, 5000);
    // });



    const phoneInput = document.querySelectorAll(".phone");

    phoneInput.forEach((input) => {
        input.addEventListener("input", function (e) {
            let value = input.value.replace(/\D/g, ""); // Удаляем все нецифровые символы

            if (value.startsWith("998")) {
                value = "+" + value;
            } else {
                value = "+998" + value;
            }

            if (value.length > 13) {
                value = value.substring(0, 13); // Ограничение по длине номера
            }

            input.value = value;
        });

        input.addEventListener("blur", function () {
            if (input.value === "+998") {
                input.value = ""; // Очищаем, если только код страны
            }
        });
    });


});
